(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.na_main_slider', {
    loop: false,
    slidesPerView: 2,
    spaceBetween: 30,
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 30
      }
    }
  });
  
  // Rest of your JavaScript remains the same
  document.querySelectorAll('.na_atc_form').forEach(form => {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      const form = this;
      const button = form.querySelector('.na_atc_button');
      const originalText = button.innerHTML;
      
      button.innerHTML = 'Adding...';
      button.disabled = true;
      
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: form.querySelector('input[name="id"]').value,
            quantity: 1
          }]
        })
      })
      .then(response => response.json())
      .then(data => {
        button.innerHTML = 'Added!';
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 1500);
        
        if (typeof updateCartCount !== 'undefined') {
          updateCartCount();
        }
      })
      .catch(error => {
        console.error('Error:', error);
        button.innerHTML = 'Error';
        setTimeout(() => {
          button.innerHTML = originalText;
          button.disabled = false;
        }, 1500);
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
